import { addDays } from "date-fns";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Swal from "sweetalert2";
import Button from "../../components/Button";
import Select from "../../components/Dropdown/index";
import InputField from "../../components/InputField/index";
import Loader from "../../components/Loader";
import Modal from "../../components/Modal";
import config from "../../configs";
import apiroutes from "../../services/apiroutes";
import { request, requestSetting } from "../../services/apiservice";
import { requestWallet } from "../../services/apiserviceWallet";
import { getAuth, setAuth, setAuthWallet } from "../../services/auth";
import BookSeat from "./BookSeat";
import "./index.css";
import configs from "../../configs";
import { decrypt, encrypt } from "../../components/util";

export const HomeComponent = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [popularData, setPopularData] = useState([]);
  const [routeLoading, setRouteLoading] = useState(true);
  const [bookRouteNowVisible, setBookRouteNowVisible] = useState(false);
  const [popularRouteDestination, setPopularRouteDestination] = useState("");
  const [popularRouteDeparture, setPopularRouteDeparture] = useState("");
  const [popularRouteDepartureId, setPopularRouteDepartureId] = useState("");
  const [popularRouteDestinationId, setPopularRouteDestinationId] =
    useState("");
  const [departureTerminal, setDepartureTerminal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [adult, setAdult] = useState("1");
  const token = getAuth();
  const [toggleState, setToggleState] = useState(1);
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const partnerId = urlParams.get("partnerId");
  const partnerIdBackup = JSON.parse(localStorage.getItem("partnerId"));
  localStorage.setItem(
    "partnerId",
    JSON.stringify(partnerId ? partnerId : partnerIdBackup)
  );

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const history = useHistory();
  useEffect(() => {
    getToken();
    // getWalletToken();
    // popularRoute();
    localStorage.removeItem("hireEmailAmount");
    localStorage.removeItem("transEmailAmount");
    localStorage.removeItem("estimatedTravelDistance");
    localStorage.removeItem("allHireDetails");
    localStorage.removeItem("selectedHireBuses");
    localStorage.removeItem("busNameQantity");
    localStorage.removeItem("returnPickupDate");
    localStorage.removeItem("userSelect");
    localStorage.removeItem("allTripDetails");
    localStorage.removeItem("selectedBusData");
    localStorage.removeItem("selectedSeats");
    localStorage.removeItem("selectedSeatsReturn");
    localStorage.removeItem("selectedReturnBusData");
    localStorage.removeItem("wovenAccountDetails");
    localStorage.removeItem("walletUserDetails");
    localStorage.removeItem("wovenWalletAccountDetails");
    localStorage.removeItem("walletPin");
    localStorage.removeItem("adults");
    localStorage.removeItem("adultsRound");
    localStorage.removeItem("retainBus");
    localStorage.removeItem("retainBusReturn");
  }, []);

  const getToken = async () => {
    const loginDetails = {
      userName: configs.USERNAME,
      password: configs.PASSWORD,
      deviceToken: "string",
      countryId: 1,
      clientId: configs.USERNAME,
    };

    const key = configs.ENCRYPT_KEY;
    const iv = configs.ENCRYPT_IV;

    const { ciphertext } = await encrypt(loginDetails, key, iv);

    const loginPayload = { credentials: ciphertext };

    request(apiroutes.GetToken(), "post", loginPayload)
      .then(async (res) => {
        const decryptedData = await decrypt(res.data.data, key, iv);

        setAuth(decryptedData?.Data?.JwtToken);
        setTimeout(() => getDepartureTerminal(), 1500);
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  const getDepartureTerminal = () => {
    requestSetting(apiroutes.DepartureTerminals(), "get", null, getAuth())
      .then((res) => {
        setDepartureTerminal(res.data?.data?.userData);
      })
      .catch((err) => {
        console.log(err.response);
        // if (err?.response?.status == 401) {
        //   getRefreshToken();
        // }
      });
  };

  const getRefreshToken = () => {
    const payload = {
        token: getAuth(),
        refreshToken: "string"
    }
    request(apiroutes.GetNewToken(), "post", payload, null)
      .then((res) => {
        setAuth(res?.data?.data?.token);
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((err) => {
        console.log(err.response);
        // alert("Session Expired, Please log in");
        // history.push("/login");
      });
  };

  const adults = [];
  for (let i = 1; i <= 13; i++) {
    adults.push(i);
  }
  const adultOptions = adults.map((x) => ({ label: x, value: x }));

  const colorStyles = {
    option: (provided, state) => ({
      ...provided,
      borderBottom: "1px dotted black",
      color: state.isSelected ? "white" : "black",
    }),
    singleValue: () => {
      const color = "black";

      return { color };
    },
  };

  const handleOneWay = (e) => {
    e.preventDefault();
    const newStartDate = new Date(startDate);
    let date = JSON.stringify(newStartDate);
    date = date.slice(1, 11);
    setLoading(true);
    const bookingData = {
      DepartureTerminalId: popularRouteDepartureId,
      DestinationTerminalId: popularRouteDestinationId,
      DepartureDate: date,
      NumberOfAdults: adult,
      TripType: "0",
      BookingType: "0",
      NumberOfChildren: "0",
    };

    const userSelect = {
      noOfAdult: adult,
      date: startDate,
      departureName: popularRouteDeparture.replace("=>", "-"),
      arrivalName: popularRouteDestination.replace("=>", "-"),
    };

    localStorage.setItem("userSelect", JSON.stringify(userSelect));

    request(apiroutes.BookingSearch(), "post", bookingData, token)
      .then((res) => {
        setLoading(false);
        if (res.data.Object === null) {
          // alert("Error validating your request, Please try again!");
          Swal.fire({
            showConfirmButton: false,
            timer: 4000,
            text: `Error validating your request, Please try again!`,
            icon: "error",
          });
          history.push("/");
          window.location.reload();
        } else {
          localStorage.setItem(
            "allTripDetails",
            JSON.stringify(res.data.Object)
          );
          history.push("/select-bus");
        }
      })
      .catch((err) => {
        // console.log(err.response);
        setLoading(false);
      });
  };

  const popularRoute = () => {
    request(apiroutes.GetpopularRoute(), "get")
      .then((res) => {
        // console.log(res);
        const data = res.data.Object;
        // console.log(data);
        setPopularData(data);
        setRouteLoading(false);
        // setAuthWallet(data);
      })
      .catch((err) => {
        // alert(err);
        console.log(err);
      });
  };

  const bookRouteNow = (item) => {
    // console.log(item, "Here are the popular items");
    setBookRouteNowVisible(true);
    setPopularRouteDestination(item.DestinationTerminalName);
    setPopularRouteDeparture(item.DepartureTerminalName);
    setPopularRouteDepartureId(item.DepartureTerminalId);
    setPopularRouteDestinationId(item.DestinationTerminalId);
  };

  const toggleModalClose = () => {
    setBookRouteNowVisible(false);
    // window.location.reload();
  };

  const width = 500;
  const height = 580;
  // const modalTitle = `Book a Bus from ${popularRouteDeparture} to ${popularRouteDestination}`;
  const modalTitle = `Book a Bus from ${popularRouteDeparture.replace(
    "=>",
    "-"
  )} to ${popularRouteDestination.replace("=>", "-")}`;
  const modalPar = "Please enter details below to proceed.";
  const modalBody = (
    <div>
      <label htmlFor="departure" className="label-auth">
        Travelling From
      </label>
      <InputField
        type="text"
        // placeholder="Verification code"
        value={popularRouteDeparture}
        onChangeMethod={(e) => setPopularRouteDeparture(e.target.value)}
        readonly={true}
      />
      <br />
      <br />
      <label htmlFor="arrival">Travelling To</label>
      <InputField
        type="text"
        // placeholder="Demmah16@gmail.com"
        value={popularRouteDestination}
        onChangeMethod={(e) => setPopularRouteDestination(e.target.value)}
        readonly={true}
      />
      <br />
      <br />
      <div className="row row-grid">
        <div className="col-md-6">
          <label className="label-auth">Departure Date</label>
          <DatePicker
            placeholderText="Select Date"
            selected={startDate}
            minDate={addDays(new Date(), 1)}
            maxDate={addDays(new Date(), 14)}
            onChange={(date) => setStartDate(date)}
            className="black"
            // readOnly={true}
          />
        </div>
        <div className="col-md-6">
          <label className="label-auth">Adults</label>
          <Select
            options={adultOptions}
            handleChange={(e) => setAdult(e.value)}
            defaultValue={{ label: "1", value: 1 }}
            value={adult}
            styles={colorStyles}
          />
        </div>
      </div>
      <br />
      <br />
      {/* <Button
        text="Proceed"
        handleButtonClick={verifyCode}
        disabled={!verificationCode}
        type="button"
      /> */}
      <div className="row">
        <div className="col-md-12">
          <Button
            text={
              loading ? (
                <div
                  style={{
                    display: "flex",
                    margin: "0 auto",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "200px",
                    transform: "translateX(-10px)",
                  }}
                >
                  <Loader dark={false} />{" "}
                  <p style={{ display: "inline-block" }}>Looking for Buses</p>
                </div>
              ) : (
                "Proceed"
              )
            }
            handleButtonClick={handleOneWay}
            type="button"
            btnstyle={{
              background: "#1BB3F5 ",
              color: "white",
              margin: "20px 0px",
              // fontFamily: "Euclid Circular B",
              fontWeight: "600",
              fontSize: "16px",
              lineHeight: "24px",
            }}
            disabled={!(startDate && adult)}
          />
        </div>
      </div>
    </div>
  );

  const settings = {
    dots: false,
    infinite: true,
    speed: 200,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          // dots: true,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 490,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          // dots: true,
          autoplay: false,
        },
      },
    ],
  };

  return (
    <div id="top" style={{ width: "100vw", overflowX: "hidden" }}>
      <Modal
        width={width}
        height={height}
        visible={bookRouteNowVisible}
        title={modalTitle}
        paragraph={modalPar}
        body={modalBody}
        handleClose={toggleModalClose}
      />
      {/* <Navbar /> */}
      <section className="hero-bg">
        <div className="container">
          {/* <Link to="/">
            <svg
              width="146"
              height="35"
              viewBox="0 0 146 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="Group_19010">
                <g id="Group_19009">
                  <path
                    id="Subtraction_6"
                    d="M133.9 22.3799C133.141 22.3799 132.386 22.304 131.646 22.1522C130.213 21.858 128.856 21.2887 127.646 20.4679C125.848 19.2533 124.439 17.5405 123.595 15.5431C123.31 14.8646 123.092 14.1624 122.945 13.4412C122.641 11.9562 122.641 10.419 122.945 8.93394C123.239 7.50109 123.808 6.14416 124.629 4.9343C125.843 3.13613 127.551 1.72701 129.549 0.877738C130.227 0.593065 130.93 0.374818 131.651 0.227737C133.141 -0.0759124 134.673 -0.0759124 136.163 0.227737C137.596 0.521897 138.953 1.09124 140.162 1.91204C141.961 3.12664 143.37 4.83467 144.214 6.83211C144.499 7.51058 144.717 8.21277 144.864 8.93394C145.168 10.419 145.168 11.9562 144.864 13.4412C144.57 14.8741 144.001 16.231 143.18 17.4409C141.965 19.239 140.257 20.6482 138.255 21.4974C137.577 21.7821 136.874 22.0004 136.153 22.1522C135.413 22.304 134.659 22.3799 133.9 22.3799ZM133.9 4.5073C133.449 4.5073 132.998 4.55474 132.552 4.64489C131.698 4.82044 130.882 5.16204 130.161 5.65073C129.089 6.37664 128.244 7.39671 127.741 8.59234C127.57 8.99562 127.438 9.41788 127.352 9.84963C127.172 10.7369 127.172 11.6573 127.352 12.5445C127.528 13.3985 127.869 14.2098 128.358 14.9358C129.084 16.0128 130.104 16.8525 131.3 17.3602C131.703 17.531 132.125 17.6639 132.552 17.7493C133.439 17.9296 134.355 17.9296 135.247 17.7493C136.101 17.5737 136.912 17.2321 137.638 16.7434C138.711 16.0175 139.555 14.9974 140.058 13.8018C140.229 13.3985 140.362 12.9763 140.447 12.5445C140.627 11.6573 140.627 10.7369 140.447 9.84963C140.272 8.99562 139.93 8.17956 139.441 7.45365C138.715 6.38139 137.695 5.53686 136.5 5.03394C136.096 4.86314 135.674 4.73029 135.247 4.64489C134.801 4.55 134.35 4.5073 133.9 4.5073Z"
                    fill="#27B6EA"
                  />
                  <g id="Group_19008">
                    <path
                      id="Path_25841"
                      d="M8.29492 18.3409H10.0741V22.0559H10.1358C11.004 19.5366 13.4665 17.9187 16.1234 18.1274V20.0632C12.6219 19.8782 10.2307 22.4592 10.2307 25.7471V34.1971H8.29492V18.3409Z"
                      fill="#475467"
                    />
                    <path
                      id="Path_25842"
                      d="M30.2852 18.3438H32.4344L37.4114 32.2547H37.4731L42.3837 18.3438H44.3811L38.4552 34.1905H36.3961L30.2852 18.3438Z"
                      fill="#475467"
                    />
                    <path
                      id="Path_25843"
                      d="M46.1936 25.1578C46.502 22.2732 48.248 19.5071 51.4126 19.5071C54.5439 19.5071 56.3611 22.24 56.4465 25.1578H46.1936ZM58.387 26.7852C58.5436 22.3301 56.5129 17.875 51.4173 17.875C46.3786 17.875 44.2578 22.0834 44.2578 26.2633C44.2578 30.7801 46.3786 34.6469 51.4173 34.6469C55.4122 34.6469 57.495 32.5593 58.3253 28.963H56.3896C55.7728 31.3589 54.2355 33.0195 51.4126 33.0195C47.6928 33.0195 46.222 29.6082 46.1936 26.7852H58.387Z"
                      fill="#475467"
                    />
                    <path
                      id="Path_25844"
                      d="M61.0293 12.2578H62.9603V34.1917H61.0293V12.2578Z"
                      fill="#475467"
                    />
                    <path
                      id="Path_25845"
                      d="M76.1693 22.9832C76.0744 20.5872 74.2335 19.5149 72.0225 19.5149C70.305 19.5149 68.2791 20.1886 68.2791 22.2478C68.2791 23.97 70.2433 24.5821 71.5671 24.9189L74.1481 25.5025C76.359 25.8394 78.6649 27.1299 78.6649 29.8959C78.6649 33.3357 75.2535 34.6547 72.3025 34.6547C68.616 34.6547 66.1014 32.9324 65.793 29.0657H67.7287C67.8853 31.6751 69.8163 33.0273 72.3973 33.0273C74.2098 33.0273 76.7243 32.2303 76.7243 30.0193C76.7243 28.1737 75.0068 27.5616 73.2561 27.1299L70.7652 26.5795C68.2459 25.9011 66.3433 25.0423 66.3433 22.3379C66.3433 19.1116 69.5032 17.8828 72.3025 17.8828C75.467 17.8828 77.9864 19.5434 78.1097 22.9832H76.1693Z"
                      fill="#475467"
                    />
                    <path
                      id="Path_25846"
                      d="M99.4501 28.0456C99.4785 31.1485 96.8691 33.0226 93.9227 33.0226C92.1103 33.0226 90.3881 31.827 90.3881 29.8912C90.3881 26.7883 94.4731 26.8215 97.7563 26.2332C98.2782 26.143 99.1417 25.9912 99.3884 25.531H99.4501L99.4501 28.0456ZM99.4501 31.7843V34.1945H101.376V22.9832C101.376 18.7463 98.3446 17.8828 95.5548 17.8828C91.93 17.8828 89.3158 19.4817 89.1308 23.1967H91.0618C91.1234 20.6204 92.9074 19.5102 95.3034 19.5102C97.576 19.5102 99.4501 20.1554 99.4501 22.7649C99.4501 24.5157 98.5581 24.7292 96.964 24.9142C92.784 25.4076 88.457 25.5595 88.457 30.0146C88.457 33.2029 90.853 34.65 93.7709 34.65C96.7172 34.65 98.1074 33.554 99.4216 31.6087C99.4216 31.6135 99.4501 31.604 99.4501 31.7843Z"
                      fill="#475467"
                    />
                    <path
                      id="Path_25847"
                      d="M27.6236 28.0456C27.6521 31.1485 25.0426 33.0226 22.0915 33.0226C20.2791 33.0226 18.5616 31.827 18.5616 29.8912C18.5616 26.7883 22.6466 26.8215 25.9346 26.2332C26.4565 26.143 27.3153 25.9912 27.562 25.531H27.6236V28.0456ZM27.6236 31.7843V34.1945H29.5452V22.9832C29.5452 18.7463 26.5134 17.8828 23.7189 17.8828C20.0941 17.8828 17.4846 19.4817 17.2996 23.1967H19.2353C19.2923 20.6204 21.0762 19.5102 23.4722 19.5102C25.7448 19.5102 27.6189 20.1554 27.6189 22.7649C27.6189 24.5157 26.7269 24.7292 25.1328 24.9142C20.9576 25.4076 16.6211 25.5595 16.6211 30.0146C16.6211 33.2029 19.0171 34.65 21.935 34.65C24.8861 34.65 26.2715 33.554 27.5857 31.6087C27.5904 31.6135 27.6236 31.604 27.6236 31.7843Z"
                      fill="#475467"
                    />
                    <path
                      id="Path_25848"
                      d="M104.637 18.341H106.425V22.056H106.487C107.355 19.5319 109.818 17.9187 112.479 18.1275V20.0633C108.978 19.8782 106.582 22.4592 106.582 25.7472V34.1972H104.641L104.637 18.341Z"
                      fill="#475467"
                    />
                    <path
                      id="Path_25849"
                      d="M115.695 13.5781H117.631V18.3416H120.853V19.969H117.631V30.6584C117.631 31.9157 117.811 32.6511 119.197 32.746C119.752 32.746 120.307 32.7128 120.857 32.6511V34.3069C120.274 34.3069 119.719 34.3686 119.14 34.3686C116.559 34.3686 115.667 33.5099 115.7 30.8055L115.695 13.5781Z"
                      fill="#475467"
                    />
                    <path
                      id="Path_25850"
                      d="M81.3268 13.5781H83.2673V18.3416H86.4889V19.969H83.2673V30.6584C83.2673 31.9157 83.4476 32.6511 84.833 32.746C85.3881 32.746 85.9385 32.7128 86.4889 32.6511V34.3069C85.9053 34.3069 85.3549 34.3686 84.7666 34.3686C82.1856 34.3686 81.2984 33.5099 81.3268 30.8055V13.5781Z"
                      fill="#475467"
                    />
                    <path
                      id="Path_25851"
                      d="M0.000887887 13.5781H1.93665V18.3416H5.15819V19.969H1.93665V30.6584C1.93665 31.9157 2.11695 32.6511 3.50235 32.746C4.05746 32.746 4.60782 32.7175 5.15819 32.6511V34.3069C4.57935 34.3069 4.02424 34.3686 3.44067 34.3686C0.859648 34.3686 -0.0323219 33.5099 0.000889795 30.8055L0.000887887 13.5781Z"
                      fill="#475467"
                    />
                  </g>
                </g>
              </g>
            </svg>{" "}
          </Link> */}
          <div className="hero-flex">
            <div className="left-card align-self-center">
              <h1>The modern way to commute across cities</h1>
              <br />
              <p>
                Why choose between the sky and the road when you can have both?
                Say hello to affordable alternatives without sacrificing
                safety or comfort.
              </p>
            </div>

            <div className="right-card">
              <section id="open-positions">
                <div
                  className="position-filters"
                  style={{ justifyContent: "center" }}
                >
                  <label
                    className={
                      toggleState === 1
                        ? "tabb-label active-tabs"
                        : "tabb-label"
                    }
                    onClick={() => toggleTab(1)}
                  >
                    Book a Seat
                  </label>
                  {/* <label
                      className={
                        toggleState === 2
                          ? "tabb-label active-tabs"
                          : "tabb-label"
                      }
                      onClick={() => toggleTab(2)}
                    >
                      Hire a bus
                    </label>
                    <label
                      className={
                        toggleState === 3
                          ? "tabb-label active-tabs"
                          : "tabb-label"
                      }
                      onClick={() => toggleTab(3)}
                    >
                      Booking status
                    </label> */}
                </div>
                <div className="positions">
                  <div
                    className={
                      toggleState === 1
                        ? "position-group  active-content"
                        : "position-group"
                    }
                  >
                    <div className="position-post">
                      <BookSeat departureTerminal={departureTerminal} />
                    </div>
                  </div>
                  {/* <div
                    className={
                      toggleState === 2
                        ? "position-group  active-content"
                        : "position-group"
                    }
                  >
                    <div className="position-post">
                      <HireBus />
                    </div>
                  </div>
                 
                  <div
                    className={
                      toggleState === 3
                        ? "position-group  active-content"
                        : "position-group"
                    }
                  >
                    <div className="position-post">
                      <BookStatus />
                    </div>
                  </div> */}
                  {/* </div> */}
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>

      {/* <Footer /> */}
    </div>
  );
};
export default HomeComponent;
